export default __webpack_public_path__ + "static/NomineeBlackBG-50bfc65e8f273cff89fbdc33dbf5193c.jpg";